<template>
  <div :class="`session-card`" @click="openReminderDetails" data-test-id="reminder-card">
    <div class="session-card__content">
      <div class="session-card__content__info">
        <div class="reminder-card-title">
          <span>{{ cycle.name }}</span>
          <span class="reminder-card-title__cycle-date">{{
            t('admin.reminders.cycle-periods', {
              startDate: moment(cycle.startDate).format('DD MMMM YYYY'),
              endDate: moment(cycle.endDate).format('DD MMMM YYYY'),
            })
          }}</span>
          <div style="display: flex; flex-wrap: wrap; gap: 0.5rem">
            <Badge v-for="program in cycle.programs" :key="program.id" variant="info">{{
              program.name
            }}</Badge>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from 'moment'

import type { AdminReminderCardType } from '@/features/admin/reminders/types'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { useI18n } from '@/lib/i18n'
import Badge from '@/components/Badge.vue'

const props = defineProps<{
  cycle: AdminReminderCardType
}>()
console.log('props', props.cycle)
const { t } = useI18n()

function openReminderDetails() {
  modalsStore.updateModalAttachedData('admin-reminder-structure', { reminderId: props.cycle.id })
  modalsStore.toggleModal('admin-reminder-structure', true)
}
</script>

<style lang="scss">
@import './reminder-card.scss';
</style>
